import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Loader2, AlertTriangle } from 'lucide-react'
import { ROLE_HOME, ROUTES } from '@/config/routes'
import useAuthStore from '@/stores/authStore'

const TIMEOUT_MS = 20_000

export default function AuthCallback() {
  const navigate  = useNavigate()
  const [timedOut, setTimedOut] = useState(false)

  const user    = useAuthStore((s) => s.user)
  const profile = useAuthStore((s) => s.profile)
  const loading = useAuthStore((s) => s.loading)

  // Timeout safety net
  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), TIMEOUT_MS)
    return () => clearTimeout(timer)
  }, [])

  // Navigate once store has resolved
  useEffect(() => {
    if (loading) return
    if (user && profile) {
      navigate(ROLE_HOME[profile.role] ?? ROUTES.BOOK, { replace: true })
    } else if (user && !profile) {
      navigate('/setup-profile', { replace: true })
    }
  }, [loading, user, profile, navigate])

  if (timedOut) {
    return (
      <div className="min-h-dvh flex flex-col items-center justify-center bg-surface-base px-4 text-center gap-4">
        <div className="w-12 h-12 bg-siglat-red/15 rounded-full flex items-center justify-center">
          <AlertTriangle className="w-6 h-6 text-siglat-red" />
        </div>
        <div>
          <p className="text-ink-primary font-semibold mb-1">Sign-in failed</p>
          <p className="text-sm text-ink-muted">Something went wrong. Please try again.</p>
        </div>
        <button
          onClick={() => navigate(ROUTES.LOGIN, { replace: true })}
          className="text-sm text-siglat-teal hover:underline mt-2"
        >
          Back to sign in
        </button>
      </div>
    )
  }

  return (
    <div className="min-h-dvh flex flex-col items-center justify-center bg-surface-base gap-4">
      <div className="w-14 h-14 bg-siglat-teal/15 rounded-xl flex items-center justify-center animate-pulse">
        <span className="text-siglat-teal text-lg font-black">SK</span>
      </div>
      <div className="flex flex-col items-center gap-2">
        <Loader2 className="w-5 h-5 text-siglat-teal animate-spin" />
        <p className="text-sm text-ink-muted">Signing you in…</p>
      </div>
    </div>
  )
}
